import { observer } from "mobx-react";
import React from "react";
import { Modal, Stack, Text, Button, ThemeIcon, Group } from "@mantine/core";
import { IconCheck, IconReload } from "@tabler/icons-react";

import { BOB_MODALS } from "../../helpers/constants";
import { Bob } from "../../stores/Bob";

// Shown after a change that only takes effect on a fresh page load
// (history days, 2FA timeout, new vault, ...). It is the ONE message for
// that change: it says what was saved, then offers the reload. It cannot be
// dismissed, because the page is out of date until it reloads.
const MustRefreshPage = observer(({ bob }: { bob: Bob }) => {
  const handleReload = () => (window.location.href = "/w");

  return (
    <Modal
      opened={bob.openModal === BOB_MODALS.YOU_MUST_REFRESH_THE_PAGE}
      onClose={() => {}}
      withCloseButton={false}
      closeOnClickOutside={false}
      closeOnEscape={false}
      trapFocus
      centered
      size="sm"
    >
      <Stack align="center" gap="md" py="md">
        <ThemeIcon size={56} radius="xl" color="green" variant="light">
          <IconCheck size={32} />
        </ThemeIcon>
        <Text fw={700} fz="lg" ta="center">
          {bob.mustRefreshMessage || "Saved."}
        </Text>
        <Text c="dimmed" fz="sm" ta="center">
          Reload the page to see the change.
        </Text>
        <Group justify="center" mt="xs">
          <Button
            leftSection={<IconReload size={18} />}
            onClick={handleReload}
            data-autofocus
          >
            Reload now
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
});

export default MustRefreshPage;
